import { gql } from '@apollo/client';

export const AGENT_ACTIVITIES_FRAGMENT = gql`
  fragment AgentActivitiesFragment on AgentActivities {
    appsSubmitted
    binds
    lastActivityDate
    quotesOutstanding
  }
`;
